import(/* webpackMode: "eager" */ "/codebuild/output/src3389300352/src/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppProviders"] */ "/codebuild/output/src3389300352/src/src/app/providers.tsx");
